import { createApp } from 'vue'
import App from './App.vue'
import './assets/styles/common.css'
import { applyTheme } from './utils/theme'

applyTheme()
createApp(App).mount('#app')
